import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MadbIncidentSearch } from '../routes/mars/models/madb-incident-search';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  constructor(private http: HttpClient) {}

  userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  marsMadbIncident: BehaviorSubject<any> = new BehaviorSubject<any>({});

  readonly marsIncidentForm = inject(FormBuilder).group({
    incidentId: [0],
    madbIncidentId: [0],
    madbIncident: [null],
    toArea: [0],
    toAreaName: [null],
    classificationId: [null, Validators.required],
    classificationName: [null],
    classificationTypeId: [null, Validators.required],
    classificationTypeName: [null, Validators.required],
    categoryId: [{ value: null, disabled: true }, Validators.required],
    categoryName: [null],
    malfunctionTypeId: [null],
    malfunctionTypeName: [null],
    lastName: [null],
    firstName: [null],
    jumperName: [null],
    personnelId: [0],
    contactEmail: [null],
    malfunctionDate: [null, Validators.required],
    homeBaseId: [0],
    homeBase1: [null, Validators.required],
    spikeBaseId: { value: 0, disabled: true },
    jumperBaseId: [0],
    homBase2: [null],
    incorrectProcedure: [null],
    inServiceError: [false],
    inspectionError: [false],
    manufacturingError: [false],
    cargoInTow: [false],
    travelModeId: [0],
    roundJumps: [
      0,
      Validators.compose([Validators.pattern('[0-9]{0,4}'), Validators.maxLength(5)])
    ],
    squareJumps: [
      0,
      Validators.compose([Validators.pattern('[0-9]{0,4}'), Validators.maxLength(5)])
    ],
    totalJumps: [
      0,
      Validators.compose([Validators.pattern('[0-9]{0,4}'), Validators.maxLength(5)])
    ],
    seasonJumps: [null, Validators.pattern('[0-9]{0,3}')],
    bodyWeight: [{value: null, disabled: true}, Validators.compose([Validators.pattern('[0-9]{0,3}')])],
    daysSince: [{value: null, disabled: true}, Validators.pattern('[0-9]{0,4}')],
    jumpType: [null],
    fireName: [null],
    reserveDeployed: [null],
    jumperNarrative: [null, Validators.maxLength(4000)],
    witness: [null],
    witnessDetails: [null],
    witnessStatement: [null, Validators.maxLength(4000)],
    jumperStatement: [null, Validators.maxLength(4000)],
    department: [null],
    foreman: [null],
    foremanDetails: [null],
    conclusion: [null, Validators.compose([Validators.maxLength(4000)])],
    responsibleDept: [null],
    responsibleDept2: [null],
    mainDeployed: [null],
    mainChuteCutaway: [null],
    mainParachute: [null],
    mainNum: [null],
    mainManufId: [null],
    mainInServiceDate: [null],
    mainRiggerId: [null],
    mainRigDate: [null, []],
    mainRigLocDetails: [null],
    mainRigLocId: [null],
    mainRiggerSpikeBaseId: [0],
    mainRiggerSpikeBaseDetails: [null],
    mainRigLocName: [null],
    mainRigManufId: [0],
    mainRigManufDetails: [null],
    mainRigManufName: [null],
    serviceDate: [formatDate(new Date(), 'MM/dd/yyyy', 'en-US')],
    mode: [null],
    mission: [null],
    otherCanopyTypeId: [0],
    jumpsOnMain: [null, Validators.compose([Validators.pattern('[0-9]{0,4}')])],
    reserveNum: [null],
    reserveChute: [null],
    reserveParachuteDetails: [null],
    reserveRigManufId: [0],
    reserveRigManufDetails: [null],
    reserveDeployedBy: [null],
    reserveRiggerId: [null],
    reserveRiggerDetails: [null],
    reserveRigDate: [null],
    reserveRigLocId: [0],
    reserveRigLocDetails: [null],
    reserveRigLocName: [null],
    reserveRigManufName: [null],
    reserveServiceDate: [null],
    deploymentMethod: [null],
    harnessNum: [null],
    loftNarrativeAuth: [null],
    loftNarrative: [null],
    videoPreview: [null],
    videoType: [null],
    photoInputOne: [null],
    photoInputTwo: [null],
    photoInputThree: [null],
    videoInput: [null],
    pic1toUpload: [null],
    pic2toUpload: [null],
    pic3toUpload: [null],
    videoToUpload: [null],
    picPreview1: [null],
    picPreview2: [null],
    picPreview3: [null],
    picFormat1: [null],
    picFormat2: [null],
    picFormat3: [null],
    picId1: [null],
    picId2: [null],
    picId3: [null],
    picDesc1: [null, Validators.maxLength(4000)],
    picDesc2: [null, Validators.maxLength(4000)],
    picDesc3: [null, Validators.maxLength(4000)],
    positionInStick: [null],
    trainee: [null],
    totalCareerJumpsToDate: [{value: null, disabled: true}],
    totalJumpsThisYearToDate: [{value: null, disabled: true}],
    drgRiggerId: [null],
    drgRiggerDetails: [null],
    drgRiggerDate: [null, []],
    drgServiceDate: [null, []],
    drgRigLocationId: [null],
    drgRigLocationDetails: [null],
    drgRiggerSpikeBaseID: [null],
    drgRiggerSpikeBaseDetails: [null],
    drgRigLocationName: [null],
    drgRigManufId: [null],
    drgManufName: [null],
    drgName: [null],
    mainCanopyCutaway: [false],
    jumpLocation: [null],
    createUser: [this.userInfo.email],
    createDate: [formatDate(new Date(), 'MM/dd/yyyy', 'en-US')],
    modifyUser: [this.userInfo.email],
    modifyDate: [formatDate(new Date(), 'MM/dd/yyyy', 'en-US')],
    deleted: [null],
    yardsDrift: [null, Validators.pattern('[0-9]{0,5}')],
    streamerTime: [null, Validators.pattern('[0-9]{0,5}')],
    temp: [null, Validators.pattern('[0-9]{0,5}')],
    jumpSpotElevationMSL: [null, Validators.pattern('[0-9,.]{0,5}')],
    videoId1: [null],
    videoDesc1: [null, Validators.maxLength(4000)],
    videoFormat1: [null],
    oldRecId: [null],
    aircraft: [null],
    jumperDetails: [null],
    jumperBaseDetails: [null],
    homeBase1Details: [null],
    spikeBaseDetails: [null],
    mainRiggerDetails: [null],
    drgNum: [null],
    drgManufDetails: [null],
    witnessNarrative: [null],
    jumperNotes: [null],
    legacyData: [null],
    parachuteNotes: [null],
    status: [null],
  });

  marsIncidentFormInit = {
    incidentId: 0,
    madbIncidentId: 0,
    madbIncident: {
      href: null,
      _id: null,
      _baseCode: null,
      _timeOverFire: null,
      _sizeClass: null,
      _numberOfJumpers: null,
      _fuelType: null,
      _yardsofDrift: null,
      _pcMalfunction: null,
      _pcNumberBundles: null,
      _pcTotalWeight: null,
      year: null,
      _notes: null,
      incidentAttachment: null,
      _nameofIncident: null,
      _dispatchedFrom_Code: null,
      _returnedTo_Code: null,
      _areaId: null,
      _incidentDate: null,
      _stateId: null,
      _usfsNum: null,
      _blmNum: null,
      _agencyId: null,
      _identifierId: null,
      _methodOfTravel_Id: null,
      _hobbsTime: null,
      _departTimeMilitary: null,
      _pilotId: null,
      _copilotId: null,
      _crewHours: null,
      _spotterId: null,
      _asstSpotterId: null,
      _spotterTraineeId: null,
      _mode: null,
      _mission: null,
      _acres: null,
      _initialAttack: null,
      _type: null,
      _latitude: null,
      _longitude: null
    },
    toArea: 0,
    toAreaName: null,
    classificationId: null,
    classificationName: null,
    classificationTypeId: null,
    classificationTypeName: null,
    categoryId: null,
    categoryName: null,
    malfunctionTypeId: null,
    malfunctionTypeName: null,
    lastName: null,
    firstName: null,
    jumperName: null,
    contactEmail: null,
    malfunctionDate: null,
    homeBaseId: 0,
    homeBase1: null,
    spikeBaseId: 0,
    homeBase2: null,
    incorrectProcedure: null,
    inServiceError: false,
    inspectionError: false,
    manufacturingError: false,
    cargoInTow: false,
    aircraft: null,
    personnelId: 0,
    roundJumps: 0,
    squareJumps: 0,
    totalJumps: 0,
    seasonJumps: null,
    bodyWeight: null,
    daysSince: null,
    jumpType: null,
    fireName: null,
    reserveDeployed: null,
    jumperNarrative: null,
    witness: null,
    witnessDetails: null,
    witnessStatement: null,
    jumperStatement: null,
    department: null,
    foreman: null,
    foremanDetails: null,
    conclusion: null,
    responsibleDept: null,
    responsibleDept2: null,
    mainDeployed: false,
    mainChuteCutaway: null,
    mainNum: null,
    mainInServiceDate: null,
    mainParachute: null,
    mainManufId: null,
    mainRiggerId: null,
    mainRigDate: null,
    mainRigLocDetails: null,
    mainRigLocId: null,
    mainRiggerSpikeBaseId: 0,
    mainRiggerSpikeBaseDetails: null,
    mainRigLocName: null,
    mainRigManufId: 0,
    mainRigManufName: null,
    mainRigManufDetails: null,  
    serviceDate: null,
    mode: null,
    mission: null,
    otherCanopyTypeId: 0,
    jumpsOnMain: null,
    reserveNum: null,
    reserveChute: null,
    reserveParachuteDetails: null,
    reserveRiggerId: null,
    reserveRiggerDetails: null,
    reserveRigDate: null,
    reserveRigLocId: 0,
    reserveRigLocDetails: null,
    reserveRigLocName: null,
    reserveRigManufId: 0,
    reserveRigManufDetails: null,
    reserveDeployedBy: null,
    reserveRigManufName: null,
    reserveServiceDate: null,
    deploymentMethod: null,
    harnessNum: null,
    loftNarrativeAuth: null,
    loftNarrative: null,
    videoPreview: null,
    videoType: null,
    pic1toUpload: null,
    pic2toUpload: null,
    pic3toUpload: null,
    videoToUpload: null,
    picPreview1: null,
    picPreview2: null,
    picPreview3: null,
    picFormat1: null,
    picFormat2: null,
    picFormat3: null,
    picId1: null,
    picId2: null,
    picId3: null,
    picDesc1: null,
    picDesc2: null,
    picDesc3: null,
    positionInStick: null,
    trainee: null,
    totalCareerJumpsToDate: null,
    totalJumpsThisYearToDate: null,
    drgRiggerId: null,
    drgRiggerDetails: null,
    drgRiggerDate: null,
    drgServiceDate: null,
    drgRigLocationId: null,
    drgRiggerSpikeBaseID: null,
    drgRiggerSpikeBaseDetails: null,
    drgRigLocationName: null,
    drgRigManufId: null,
    drgManufName: null,
    drgName: null,
    mainCanopyCutaway: false,
    jumpLocation: null,
    createUser: this.userInfo.email,
    createDate: formatDate(new Date(), 'MM/dd/yyyy', 'en-US'),
    modifyUser: this.userInfo.email,
    modifyDate: formatDate(new Date(), 'MM/dd/yyyy', 'en-US'),
    deleted: null,
    yardsDrift: null,
    streamerTime: null,
    temp: null,
    jumpSpotElevationMSL: null,
    videoId1: null,
    videoDesc1: null,
    videoFormat1: null,
    oldRecId: null,
    mainRiggerDetails: null,
    drgNum: null,
    drgManufDetails: null,
    witnessNarrative: null,
    jumperNotes: null,
    legacyData: null,
    parachuteNotes: null,
    status: null,
  };

  // Old Search methods, perhaps to be removed

  // private madbIncidentSearchSubject = new BehaviorSubject<string>('');
  // readonly madbIncidentSearchAction$ = this.madbIncidentSearchSubject.asObservable();

  // incidentSearch(searchText: string): Observable<any[]> {
  //   return this.http.get<any[]>(
  //     `${environment.API_URL}/incidentsearchbyname?searchText=${searchText}`
  //   );
  // }

  // public setMadbIncidentSearchAction(input: string): void {
  //   this.madbIncidentSearchSubject.next(input);
  // }

  // readonly madbIncidentAutocomplete$: Observable<MadbIncidentSearch[]> =
  //   this.madbIncidentSearchAction$.pipe(
  //     debounceTime(1000),
  //     distinctUntilChanged(),
  //     switchMap((input: string) =>
  //       (!!input && input.trim().length >= 1 ? this.incidentSearch(input) : of([])).pipe(
  //         // Additional sorting on switchMap output
  //         map((values: any[]) => values.sort((valOne, valTwo) => valOne - valTwo))
  //       )
  //     )
  //   );
}
